import * as moment from "moment-timezone";
import { FacturaCompra } from "src/app/models/Dte/FacturaCompra";
import { FacturaExportacion } from "src/app/models/Dte/FacturaExportacion";
import { IDte } from "src/app/models/Dte/IDte";
import { IndicadorServicio } from "src/app/models/Dte/IndicadorServicio.enum";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";
import { OptionsReferenceDteEmitido } from "src/app/models/Dte/OptionsReferenceDteEmitido";
import { OptionsTransportDteEmitido } from "src/app/models/Dte/OptionsTransportDteEmitido";
import { TotalDteEmitido } from "src/app/models/Dte/TotalDteEmitido";
import { GuiaDespacho } from "src/app/models/GuiaDespacho";

export function aplicarRutReceptor(dte: IDte, rut: string | null | undefined): void {
	const limpio = rut ? rut.replace(/\./g, "").replace(/-/g, "") : "";
	dte.rutReceptor = limpio ? limpio.slice(0, -1) : "66666666";
	dte.rutReceptorDv = limpio ? limpio.slice(-1) : "6";
	if (dte instanceof FacturaExportacion) dte.clienteInternacionalId = limpio ? Number(limpio) : undefined;
}

export function aplicarOpcionesTransporte(dte: IDte, opciones: OptionsTransportDteEmitido | null | undefined, invoiceType: InvoiceType): void {
	if (!opciones || (invoiceType !== InvoiceType.GuiaDespacho && !opciones.facturaAcompanaTraslado)) {
		dte.guiaDespacho = null;
		return;
	}
	const guia = new GuiaDespacho();
	const informarDestino = invoiceType === InvoiceType.GuiaDespacho || !!opciones.destinoDistintoReceptor || !!opciones.dirDest || !!opciones.cmnaDest;
	guia.rutTransporte = opciones.rutTransporte;
	guia.patente = opciones.patente;
	guia.patenteCarro = opciones.patenteCarro;
	guia.rutChofer = opciones.rutChofer;
	guia.nombreChofer = opciones.nombreChofer;
	guia.dvChofer = opciones.dvChofer;
	guia.dvTransporte = opciones.dvTransporte;
	guia.dirDest = informarDestino ? opciones.dirDest : undefined;
	guia.cmnaDest = informarDestino ? opciones.cmnaDest : undefined;
	guia.fechaSalida = opciones.fechaSalida;
	guia.horaSalida = opciones.horaSalida;
	guia.fechaLlegada = opciones.fechaLlegada;
	if (invoiceType !== InvoiceType.GuiaDespacho) guia.tipoDespacho = opciones.tipoDespacho;
	dte.guiaDespacho = guia;
	dte.mnzRolOrigen = opciones.mnzRolOrigen;
	dte.prdRolOrigen = opciones.prdRolOrigen;
	dte.codPlanConaf = opciones.codPlanConaf;
	dte.latitudOrigenMadera = opciones.latitudOrigenMadera;
	dte.longitudOrigenMadera = opciones.longitudOrigenMadera;
	dte.comunaOrigenId = opciones.comunaOrigenId;
}

export function aplicarOpcionesReferencias(dte: IDte, opciones: OptionsReferenceDteEmitido): void {
	dte.indicadorMontosNetos = !opciones.sonDetallesConIVA;
	dte.tipoMoneda = opciones.tipoMoneda;
	dte.tipoMonedaAduana = opciones.tipoMonedaAduana;
	dte.codigoMonedaAduana = opciones.codigoMonedaAduana;
	dte.dtePagado = opciones.dtePagado;
	const referencia = opciones.listaReferencias?.[0];
	if (opciones.haveDteReference) {
		if (referencia) {
			dte.razonReferencia = referencia.razonReferencia;
			dte.folioReferencia = referencia.folioReferencia;
			dte.fechaReferencia = referencia.fechaDteReferenciado;
			dte.codigoTipoDteReferencia = referencia.codigoTipoDteReferencia;
		}
		dte.listaReferenciasDteEmitido = opciones.listaReferencias;
		return;
	}
	dte.listaReferenciasDteEmitido = undefined;
	dte.razonReferencia = undefined;
	dte.folioReferencia = undefined;
	dte.fechaReferencia = undefined;
	dte.codigoTipoDteReferencia = undefined;
	dte.rutEmisor = undefined;
}

export function aplicarTotales(dte: IDte, totales: TotalDteEmitido): void {
	dte.neto = totales.netoDte;
	dte.exento = totales.exentoDte;
	dte.iva = totales.ivaDte;
	dte.total = totales.totalDte;
	dte.tipoDteId = totales.tipoDteId;
	dte.codigoTipoDte = totales.codigoTipoDte;
	dte.aplicaCredEC = !!totales.aplicaCredEC;
	dte.credEC = dte.aplicaCredEC && dte.codigoTipoDte === 33 ? Math.round(Number(dte.iva || 0) * 0.65) : 0;
	if (dte.codigoTipoDte === 33 || dte.codigoTipoDte === 34) dte.indicadorServicio = IndicadorServicio.BoletasVentaYServicios;
	if (dte.codigoTipoDte === 33 || dte.codigoTipoDte === 43) {
		dte.tieneIvaTerceros = totales.TieneIvaTerceros;
		dte.ivaTerceros = totales.ivaTerceros;
		dte.ivaPropio = totales.ivaPropio;
	}
	dte.descuentoGlobal = Number(totales.descuentoGlobal || 0);
	dte.fecha = convertirFecha(totales.fechaEmision);
	dte.formato = totales.formato?.size || 0;
	dte.diasVencimiento = totales.diasVencimiento;
	dte.formaPagoEnum = totales.formaPago;
	dte.medioPagoBoletaEnum = totales.medioPagoBoleta || null;
	dte.FormaPagoExportacionEnum = totales.formaPagoExportacion;
	dte.tipoMoneda = totales.otraMonedaEnt ? totales.otraMonedaEnt.tipoMoneda : "CLP";
	dte.otraMonedaEnt = totales.otraMonedaEnt;
	dte.DescuentoRecargoEnts = totales.descuentoRecargoEnt ? [totales.descuentoRecargoEnt] : undefined;
	dte.impuestos = totales.montoImpuestos || undefined;
	if (dte instanceof FacturaCompra) dte.retencion = totales.retencionIva;
	if (dte.guiaDespacho && dte.codigoTipoDte === 52) {
		dte.guiaDespacho.tipoTraslado = totales.tipoTraslado;
		dte.guiaDespacho.tipoDespacho = totales.tipoDespacho;
	}
	if (dte.codigoTipoDte === 43) {
		dte.comisionCargo = Number(totales.totalComisionCargos || 0) + Number(totales.exentoComisionCargos || 0) + Number(totales.netoComisionCargos || 0) + Number(totales.ivaComisionCargos || 0);
		dte.tipoMoneda = "CLP";
	}
	if (dte instanceof FacturaExportacion) {
		dte.montoClausulaVenta = totales.montoClausulaVenta;
		dte.setTotalesData(totales);
	}
}

function convertirFecha(fecha: Date | string): Date | undefined {
	if (fecha instanceof Date) return fecha;
	const valor = moment(fecha);
	return valor.isValid() ? valor.toDate() : undefined;
}
